import "jquery-touchswipe/jquery.touchSwipe";

import "bootstrap";

/* eslint-disable-next-line */
(function ($) {
	$(document).ready(function () {


		/**
		 * Modal - YouTube Embed
		 */

		$('.video-thumbnail-link').click(function () {
			var videoId = $(this).data('video-id');
			var videoSRC = "https://www.youtube.com/embed/"+videoId+"?enablejsapi=1&version=3&playerapiid=ytplayer";			
			$('.embed-responsive[data-video-id='+videoId+'] iframe').attr('src',videoSRC);
		});
		$('.btn-close').click(function(){
			var videoId = $(this).data('video-id');
			$('.embed-responsive[data-video-id='+videoId+'] iframe').attr('src','')
		})

		/**
		 * Search - Tab dropdown on mobile
		 */
		$("#search-category-dropdown-menu").on("change", function () {
			$("#search-page-filter-tabs").find(".nav-link.active").removeClass("active");
			$("#search-page-filter-tab-content").find(".tab-pane.active").removeClass("active");

			$("#search-page-filter-tabs").find(".nav-link[href='" + $(this).val() + "']").addClass("active");
			$($(this).val()).addClass("show active");
		});

		// get Cookies
		var getCookie = function (name) {
			var value = "; " + document.cookie;
			var parts = value.split("; " + name + "=");
			if (parts.length == 2) return parts.pop().split(";").shift();
		};

		// If the url contains a hash, it might be trying to deep link to a specific tab on the page
		// Scroll to and open the tab if it exists
		// Only applies to tabs inside a Tab block
		if(window.location.hash !== ""){

			const linkedTab = $(".tabs-block-block.has-child-page-tab-content").find(".nav-tabs a[href='" + window.location.hash + "']");

			if(linkedTab.length > 0){

				let scrollPosition = linkedTab.offset().top - (parseInt($("body > header").outerHeight()) + 30);

				if($("#wpadminbar").length > 0){
					scrollPosition -= $("#wpadminbar").outerHeight();
				}

				$("html, body").animate({
					scrollTop: scrollPosition,
				}, 1000);

				linkedTab.click();

			}

		}

		// Updates browser's address bar by adding click tab's ID and a hash value, to simulate page navigation
		$(".tabs-block-block.has-child-page-tab-content").each(function(){

			$(".nav-tabs [data-toggle='tab']", this).on("click", function(){

				const tabId = $(this).attr("href");
				console.log(tabId);

				window.history.pushState(null, null, tabId);

			});

		});

		/**
		 * Bucket Blocks adding hashs and checking url
		 */
		$('.bucket-card button').click( function() {
			window.location.hash = this.dataset.id;
		});

		if(window.location.hash !== ""){

			const buttonBucket = $('.bucket-card button[data-id="' + window.location.hash.substring(1) + '"]');

			if(buttonBucket.length > 0){

				buttonBucket.click();

				var headerHeight = $('header').height();
				var buttonCardHeight = buttonBucket.parent().height();
				var negativeHeight = headerHeight + buttonCardHeight + 200;

				$('html, body').animate({
					scrollTop: $(window.location.hash).offset().top - negativeHeight ,
				}, 'slow');

			}

		}

		/**
		 * Video Block and Video Shortcode Button - Enable pause on modal close
		 */
		$('.orange-youtube-video-modal').on('click', function (){
			$(this).find('.youtube-video')[0].contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
		});

		/**
		 * Carousel - Add active class to first indicator
		 */
		$('.carousel-block .carousel-indicators li:first-of-type').addClass('active');



		/**
		 * Post Slider - Bootstrap mods
		 */
		$('.post-slider .carousel-inner .carousel-item:first-of-type').addClass('active');

		$.each( $('.post-slider-block .post-slider'), function(index, slider) {
			var sliderID = '#' + $(slider).attr('id');
			/*
				CC 2.0 License Iatek LLC 2018 - Attribution required
			*/
			$( this ).on('slide.bs.carousel', function (e) {
				var $e = $(e.relatedTarget);
				var idx = $e.index();
				var itemsPerSlide = 4;
				var totalItems = $(sliderID + ' .carousel-item').length;

				if (idx >= (totalItems - (itemsPerSlide - 1))) {
					var it = itemsPerSlide - (totalItems - idx);
					for (var i = 0; i < it; i++) {

						// append slides to end
						if (e.direction === "left") {
							$(sliderID + ' .carousel-item').eq(i).appendTo(sliderID + ' .carousel-inner');
						} else {
							$(sliderID + ' .carousel-item').eq(0).appendTo(sliderID + ' .carousel-inner');
						}
					}
				}
			});
		});

		$('.social-slider .carousel-inner .carousel-item:first-of-type').addClass('active');

		$.each( $('.social-slider-block .social-slider'), function(index, slider) {
			var sliderID = '#' + $(slider).attr('id');
			/*
				CC 2.0 License Iatek LLC 2018 - Attribution required
			*/
			$( this ).on('slide.bs.carousel', function (e) {
				var $eS = $(e.relatedTarget);
				var idxS = $eS.index();
				var itemsPerSlideS = 4;
				var totalItemsS = $(sliderID + ' .carousel-item.social').length;

				console.log('total: '+totalItemsS);

				if (idxS >= (4)) {
					var it = itemsPerSlideS - (totalItemsS - idxS);
					for (var i = 0; i < it; i++) {

						// append slides to end
						if (e.direction === "left") {
							$(sliderID + ' .carousel-item.social').eq(i).appendTo(sliderID + ' .carousel-inner.social');
						} else {
							$(sliderID + ' .carousel-item.social').eq(0).appendTo(sliderID + ' .carousel-inner.social');
						}
					}
				}
			});
		});		


		/* Initialize Carousel */
		$('.carousel.ocb').carousel({
			pause: true,
		});

		/* Play trigger */
		$('.carousel-control-cycle-toggle').on("click", function() {

			var state = ($(this).hasClass("oc-pause")) ? 'cycle' : 'pause';

			var carouselId = $(this).closest(".carousel").attr("id");
			
			$("#" + carouselId).carousel(state);

			$(this).toggleClass("oc-pause");

		});


		/**
		 * Video - play video when modal opened
		 */
		$( '.video-block a.video-thumbnail-link' ).on( 'click', function () {
			$( this ).parent().find( 'video' ).trigger('play');
		});


		/**
		 * Testimonial - play/pause functionality
		 */
		/*$( '.testimonial-block a.carousel-control-pause' ).on( 'click', function(){
			var carousel = $( this ).parent().parent().attr( 'id' );

			if( $( this ).hasClass( 'paused' ) ) {
				$( '#' + carousel ).carousel('cycle');
				$( this ).toggleClass( 'paused' );

			} else {
				$( '#' + carousel ).carousel('pause');
				$( this ).toggleClass( 'paused' );
			}
		});*/

		// create function, it expects 2 values.
		/* eslint-disable-next-line */
		function insertAfter(newElement,targetElement) {
			// target is what you want it to go after. Look for this elements parent.
			var parent = targetElement.parent();
			//console.log(parent);

			// if the parents lastchild is the targetElement...
			if (parent.lastChild === targetElement) {
				// add the newElement after the target element.
				parent.appendChild(newElement);
			} else {
				// else the target has siblings, insert the new element between the target and it's next sibling.
				parent.insertBefore(newElement, targetElement.nextSibling);
			}
		}


		console.log('here');
		//need to change this to a dom listener
		setTimeout(function(){

			if($('#sb_instagram').length){
				var index = 1;
				$('.sbi_item').each(function(){
					var social_container = $('.social-container');
					if(index === 2){


						$(this).after(social_container);
						social_container.removeClass('hidden-unless-required');

					}

					index ++;

				})

			}

		},1000);

		/**
		 * Alert System
		 */
		$('#alert-carousel .carousel-inner .carousel-item:first-of-type').addClass('active');
		// Cookies
		function alertSetCookie(exdays) {
			var d = new Date();
			d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
			var expires = "expires="+d.toUTCString();
			document.cookie = 'hideAlerts' + "=" + true + ";" + expires + ";path=/";
		}

		$('#alert-system .close').click(function () { 
			alertSetCookie(7); // 7 days
		});

		var cookieVal = getCookie('hideAlerts');

		if (cookieVal) {
			$('#alert-system').hide();
		} else {
			$('#alert-system').show();
		}

		/**
		 * Form - Add class to li.gfield to identify containing input
		 */
		$( '.ginput_complex' ).parent().addClass( 'gfield_complex' );


		/**
		 * Spotlight Carousel
		 */
		$(".spotlight-carousel-block .spotlight-text-carousel")
			.on("slide.bs.carousel", function(evt){

				let spotlightImageCarousel = $(this).closest(".spotlight-carousel-block").find(".spotlight-image-carousel");

				let cycleCommand = (evt.direction === "left") ? "next" : "prev";

				spotlightImageCarousel.carousel(cycleCommand);

			})
			.find(".carousel-control-cycle-toggle").on("click", function(){

				let spotlightImageCarousel = $(this).closest(".spotlight-carousel-block").find(".spotlight-image-carousel");

				let carouselCommandKeyword = ($(this).hasClass("oc-pause")) ? "pause" : "cycle";

				spotlightImageCarousel.carousel(carouselCommandKeyword);

			});

	});
	/* eslint-disable-next-line */
})(jQuery);

